// Translation fixes for Better company name
var correct_translation = [
  { from: "Gwell", to: "Better" },
  { from: "GWELL", to: "BETTER" }
];

function textNodesUnder(el) {
  var n, a = [], walk = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null, false);
  while (n = walk.nextNode()) a.push(n);
  return a;
}

export default () => {
    
  var serviceUrl = "//api.reciteme.com/asset/js?key=";
  var serviceKey = "ac0e3b920fd10033bc227fc40e768c1f23105d4e";
  var options = {};  // Options can be added as needed
  var autoLoad = false;
  var enableFragment = "#reciteEnable";
  var loaded = [];
  var frag = false;
  var reciteLoading = false;
  var targetLanguage;
  var allCookies;

  // Check if fragment identifier enables loading
  // Assuming 'enableFragment' is a predefined variable holding the specific hash value
  if (window.location.hash === enableFragment) {
    frag = true;
  }

  var accessibilitySection = document.getElementById("accessibility-section");
  var accessibilityWarning = document.getElementById("accessibility-translation-warning");
  var accessibilityAcceptButton = document.getElementById("accessibility-translation-accept");
  var accessibilityDeclineButton = document.getElementById("accessibility-translation-decline");
  var cookieName = "translation-accept=";
  var svgLogoStyle = document.getElementById("svg-logo-style");

  accessibilityAcceptButton.addEventListener(
    'click',
    function (e) {
      var btn = document.querySelector('#recite-translation-button');
      var targetLanguage = btn ? btn.getAttribute('data-recite-translate') : null;
      _hideWarning();
      _acceptTranslation(e, targetLanguage);
      e.preventDefault();
      e.stopPropagation();
      return false;
    },
    false
  );

  accessibilityDeclineButton.addEventListener(
    'click',
    function (e) {
      _hideWarning();
      e.preventDefault();
      e.stopPropagation();
      return false;
    },
    false
  );

  if (accessibilitySection) {
    if(window.innerWidth > 769){
      var languageLabel = welsh() ? "English" : "Cymraeg";
      var languageCode = welsh() ? "en" : "cy";
      accessibilitySection.innerHTML = `
      <div id="recite-translation-button" data-recite-translate='${languageCode}' data-recite-translate-skip='true' >
      <span>${languageLabel}</span>
      </div>
      `;
      accessibilitySection.setAttribute('data-recite-translate-skip', true);
    } 
    else {
      accessibilitySection.innerHTML = `
      <div id="recite-translation-button" data-recite-translate='en' data-recite-translate-skip='true' >
      <span>English</span>
      </div>
      |
      <div id="recite-translation-button" data-recite-translate='cy' data-recite-translate-skip='true' >
      <span>Cymraeg</span>
      </div>
      `;
      accessibilitySection.setAttribute('data-recite-translate-skip', true);
      _mobileButtonActive();
    }
    
  }

  var translateButtons = document.querySelectorAll('#recite-translation-button');
  for (var i = 0; i < translateButtons.length; i++) {
    translateButtons[i].addEventListener(
      'click',
      function (e) {
        targetLanguage = this.getAttribute('data-recite-translate');
        _translationLogic(targetLanguage);
        e.preventDefault();
        e.stopPropagation();
        return false;
      },
      false
    );
  }

  if (document.addEventListener) {
    document.addEventListener("DOMContentLoaded", function () {
      loadServiceWithoutEnable();
    });
  } else {
    loadServiceWithoutEnable(); // Fallback for older browsers or immediate load
  }

  // Check persistence cookie and load if true
  if (_rc("Recite.Persist") == "true") {
    loadServiceWithoutEnable();
  }

  // Check for and handle stored language:
  if (
    _rc('Recite.Persist') === 'false' ||
    _rc('Recite.Persist') === null ||
    _rc('Recite.Persist') == 'null'
  ) {
    if ((storedLang() != 'undefined') && (storedLang() != null)) {
      _handleTranslation(storedLang());
    }
  }

  function _acceptTranslation(e, targetLanguage){
    if (targetLanguage !== 'en' && targetLanguage !== 'cy') {
      console.error('Invalid targetLanguage:', targetLanguage);
      return;
    }
    document.cookie = "translation-accept=1; path=/; max-age=31536000; Secure; SameSite=Lax";
    var currentLang = localStorage.getItem('user_lang');
    if (currentLang !== targetLanguage) {
      localStorage.setItem('user_lang', targetLanguage);
      _handleTranslation(targetLanguage);
    }
    // Update the button's data-recite-translate and label after switching
    var btn = document.querySelector('#recite-translation-button');
    if (btn) {
      if (targetLanguage === 'en') {
        btn.setAttribute('data-recite-translate', 'cy');
        btn.innerText = 'Cymraeg';
      } else {
        btn.setAttribute('data-recite-translate', 'en');
        btn.innerText = 'English';
      }
    }
  }

  function cookieString(){
    allCookies = document.cookie;
    return "; " + allCookies;
  }

  // Load ReciteMe core and schedule an initial translation:
  function loadAndTranslate(lang) {
    reciteLoading = true;
    loadScript(serviceUrl + serviceKey, function () {
      _handleTranslation(lang); //this is in the script load callback so no ‘looping’
    });
  }

  function loadScript(url, callback) {
    var script = document.createElement("script");
    script.type = "text/javascript";

    // Handle script loading completion for different browsers
    if (script.readyState) { // IE
      script.onreadystatechange = function () {
        if (script.readyState == "loaded" || script.readyState == "complete") {
          script.onreadystatechange = null;
          if (typeof callback !== 'undefined') {
            callback();
          }
        }
      };
    } else { // Other browsers
      if (typeof callback !== 'undefined') {
        script.onload = function () {
          callback();
        };
      }
    }

    // Set the source and append the script to the head
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
  }

  function loadService(callback) {
    Recite.enable();
  }

  // Make loadService globally accessible for inline onclick handlers
  window.loadService = loadService;

  function loadServiceWithoutEnable(callback) {
    var serviceIdentifier = serviceUrl + serviceKey;

    // Prevent duplicate loading
    for (var i = 0; i < loaded.length; i++) {
      if (loaded[i] == serviceIdentifier) {
        return; // Exit if already loaded or loading
      }
    }
    loaded.push(serviceIdentifier); // Mark as loading/loaded

    // Load the service script
    loadScript(serviceUrl + serviceKey, function () {
      // Execute callbacks if they exist and are functions
      if (typeof _reciteLoaded === "function") {
        _reciteLoaded(); // Global callback?
      }
      if (typeof callback == "function") {
        callback(); // Specific callback passed to loadServiceWithoutEnable
      }

      Recite.load(options);
      Recite.Event.subscribe("Recite:load", function () {
        // Recite.enable();
      });
    });
  }

  // Assess the default language of the page:
  function _getDocLang() {
    var html = document.getElementsByTagName('html');
    if (html[0].hasAttribute('lang')) {
      return html[0].getAttribute('lang');
    }
    var body = document.getElementsByTagName('body');
    if (body[0].hasAttribute('lang')) {
      return body[0].getAttribute('lang');
    }
    return null;
  }

  // Handle a translation:
  function _handleTranslation(lang) {

    if (typeof Recite != 'undefined') {
      reciteLoading = false;
      localStorage.setItem('user_lang', lang);
      Recite.Language.Translate.translate(
        document.getElementsByTagName('body')[0],
        lang
      );
      document.querySelector('html').setAttribute('lang', lang);
      if(window.innerWidth > 768){
        document
        .querySelector('#recite-translation-button')
        .setAttribute('data-recite-translate', (lang === 'en' ? 'cy' : 'en'));
        document.querySelector('#recite-translation-button').innerText =
        lang === 'en' ? 'Cymraeg' : 'English';
      }

      if (Recite.isEnabled()) {
        Recite.Preferences.set('language', lang);
      }
    } else {
      //check that we haven’t already requested this -
      if (!reciteLoading) {
        loadAndTranslate(lang);
      }
    }
  }

  function _hideWarning(){
    if(accessibilityWarning) {
      accessibilityWarning.style.display = 'none';
    }
  }

  function _rc(cookieName) {
    var nameEQ = cookieName + "=";
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      // Trim leading spaces
      while (cookie.charAt(0) == ' ') {
        cookie = cookie.substring(1, cookie.length);
      }
      // Check if cookie matches the name
      if (cookie.indexOf(nameEQ) == 0) {
        return cookie.substring(nameEQ.length, cookie.length);
      }
    }
    // Return null if cookie not found
    return null;
  }

  function _reciteLoaded() {
    Recite.Event.subscribe('Preferences:load', _syncLanguage);
    Recite.Event.subscribe('Preferences:set', _syncLanguage);
    Recite.Event.subscribe('Preferences:reset', _syncLanguage);
    // Code below will reset translation to default when recite closes.
    Recite.Event.subscribe('Recite:disable', _resetLang);

    // After translation completes, replace 'Gwell'/'gwell' with 'Better'/'better' if Welsh is active
    Recite.Event.subscribe('Translate:complete', function () {
      var lang = localStorage.getItem('user_lang');
      if (lang === 'cy') {
        var bodyNode = document.body;
        var elements = textNodesUnder(bodyNode);
        for (var i = 0; i < elements.length; i++) {
          for (var j = 0; j < correct_translation.length; j++) {
            elements[i].textContent = elements[i].textContent.replace(new RegExp(correct_translation[j].from, 'g'), correct_translation[j].to);
          }
        }
      }
    });
  }

  function reciteLoadandOpenTranslate() {
    openlang = true;
    loadServiceWithoutEnable(); // For Html Version.
  }

  function _resetLang() {
    //we should set the stored lang back to what it was when recite loaded..
    var launchLang = localStorage.getItem('launch_language');
    if (launchLang != undefined) {
      localStorage.setItem('user_lang', launchLang);
    } else {
      localStorage.removeItem('user_lang');
    }
  }

  function _mobileButtonActive() {
    if(window.innerWidth < 769){
      var lang = localStorage.getItem('user_lang');
      var enButton = document.querySelector('[data-recite-translate=en]');
      var cyButton = document.querySelector('[data-recite-translate=cy]');
      var translateButtons = document.querySelectorAll('#recite-translation-button');

      if(lang == 'cy'){
        cyButton.classList.add('active');
      } else {
        enButton.classList.add('active');
      }

      translateButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if(button.dataset.reciteTranslate == 'cy'){
            cyButton.classList.add('active');
            enButton.classList.remove('active');
          } else if(button.dataset.reciteTranslate == 'en'){
            enButton.classList.add('active');
            cyButton.classList.remove('active');
          }          
          button.classList.add('active');
        });
      });


    }
  }

  function _showWarning(){
    if(accessibilityWarning) {
      accessibilityWarning.style.display = 'flex';
      _listenForOutsideClick();
    }
  }

  function _listenForOutsideClick() {
    function handleClick(event) {
      if (
        accessibilitySection &&
        accessibilityWarning &&
        !accessibilityWarning.contains(event.target) &&
        !accessibilitySection.contains(event.target)
      ) {
        _hideWarning();
        document.removeEventListener('click', handleClick);
      }
    }
    document.addEventListener('click', handleClick);
  }

  function storedLang(){
    return localStorage.getItem('user_lang');
  }

  function _syncLanguage() {
    var lang = Recite.Preferences.get('language');
    if (lang != storedLang()) {
      localStorage.setItem('user_lang', lang);
    }
  }

  function _translationLogic(targetLanguage){
    _showWarning();
  }

  function welsh(){
    return ((typeof storedLang() !== 'undefined' && storedLang() !== null) && (typeof storedLang() === 'string' && storedLang().startsWith('cy')))
  }


}